import Link from "next/link";

interface Props {
  total?: number;
  page: number;
  pathname: string;
  params?: any;
}

export function AdminPagination({ total = 0, page, pathname, params }: Props) {
  const currentPage = page;
  const blockSize = 5;

  const currentBlock = Math.ceil(currentPage / blockSize);
  const totalBlock = Math.ceil(total / blockSize);

  const startPage = (currentBlock - 1) * blockSize + 1;
  const endPage = currentBlock * blockSize;

  const prevBlockPage = startPage - 1;
  const nextBlockPage = endPage + 1;

  const Item = () => {
    const items = [];

    for (let i = startPage; i <= endPage && i <= total; i++) {
      items.push(
        <li className={`page-item ${i === page ? "active" : ""}`} key={i}>
          <Link
            href={{ pathname, query: { ...params, page: i } }}
            className="page-link"
          >
            {i}
          </Link>
        </li>
      );
    }

    return items;
  };

  return (
    <ul className="pagination mb-0 justify-content-center">
      {currentBlock > 1 && (
        <li className={`page-item ${currentBlock === 1 && `disabled`}`}>
          <Link
            href={{
              pathname,
              query: { ...params, page: prevBlockPage },
            }}
            className="page-link"
          >
            이전
          </Link>
        </li>
      )}

      <Item />

      {currentBlock < totalBlock && (
        <li
          className={`page-item  ${currentBlock === totalBlock && `disabled`}`}
        >
          <Link
            href={{
              pathname,
              query: { ...params, page: nextBlockPage },
            }}
            className="page-link"
          >
            다음
          </Link>
        </li>
      )}
    </ul>
  );
}
